const doReplacement = (content, {search_for, replace_with, regex, group}, groupName) => {
    if (group && groupName !== group) {
        return content;
    }

    if (!regex) {
        return content.replace(search_for, replace_with);
    }

    const re = new RegExp(search_for, 'g')

    return content.replace(re, replace_with);
}

const facet_replacement = (facet, rules, groupName = null) => {
    if (rules.length === 0) {
        return facet;
    }

    rules.forEach((rule) => {
        facet = doReplacement(facet, rule, groupName);
    })

    return facet;
}
export {facet_replacement}